import qs from 'qs';

import * as types from '../constants/favorites';
import api from '../api';

export const setFilter = ({ group, id }) => (dispatch, getState) => {
  let allSelected = getState().favorites.selectedFilters;
  let exist = allSelected?.[group] || [];

  if (exist.indexOf(id) >= 0) {
    allSelected = {
      ...allSelected,
      [group]: allSelected?.[group].filter(i => i !== id),
    };
  } else {
    allSelected = {
      ...allSelected,
      [group]: exist.concat([id]),
    };
  }

  dispatch({
    type: types.SET_FILTER,
    payload: allSelected,
  });
};

export const resetFilters = () => dispatch =>
  dispatch({ type: types.RESET_FILTERS });

export const fetchProducts = (page = 1) => async (dispatch, getState) => {
  try {
    dispatch({ type: types.FETCH_PRODUCTS_BEGIN });
    let userUuid = getState().user.uuid;
    let location = getState().user.location;

    let params = {
      page,
      userUuid,
      ...getState().favorites.selectedFilters,
      latitude: location ? location.latitude : null,
      longitude: location ? location.longitude : null,
    };
    let queryString = qs.stringify(params);
    let response = await api.get('/favorites/products', {
      params,
      paramsSerializer: () => queryString,
    });

    let { data, filters, total } = response.data;

    dispatch({
      type: types.FETCH_PRODUCTS_SUCCESS,
      payload: {
        products: data,
        filters,
        total,
      },
    });
  } catch (e) {
    dispatch({ type: types.FETCH_PRODUCTS_ERROR });
    console.error(e);
  }
};
